export default __webpack_public_path__ + "static/media/image.726ccb83.png";